<template>
  <div class="card cart-product-list w-100 p-2">
    <div v-if="!true" class="d-flex align-items-center flex-column">
      <h3>{{ $t('cart.there_are_no_items_in_the_shopping_cart') }}</h3>

      <a href="/products" class='btn btn-primary d-flex align-items-center'><span class='material-icons mr-1'>home</span><span>{{ $t('action.back_to_store') }}</span></a>
    </div>

    <div v-else>
      <div v-for="item in sharedState.items" :key="item.id" class="product">
        <figure class="product-image">
          <secure-image :src="item.image_url" :default-src="item.default_image_url"></secure-image>
        </figure>
        <h6 class="product-name" v-html="formatName(item)"></h6>
        <small class="product-specifications font-weight-light text-muted" :title="extractSpecifications(item)">{{ extractSpecifications(item) }}</small>
        <div class="product-quantity">
          <button type="button" class="btn btn-sm btn-light p-0 m-1" :title="$t('action.remove')" @click="decrementItemQuantity(item)">
            <span class="material-icons">remove</span>
          </button>
          <span class="product-quantity__value">{{ item.quantity }}</span>
          <button type="button" class="btn btn-sm btn-light p-0 m-1" :title="$t('action.add')" @click="incrementItemQuantity(item)">
            <span class="material-icons">add</span>
          </button>
        </div>
        <div class="product-actions">
          <button type="button" class="btn btn-link" @click="editItem(item)">{{ $t('action.edit') }}</button>
          <button type="button" class="btn btn-link" :data-question="$t('question.are_you_sure')" :data-cancel="$t('action.cancel')" :data-confirm="$t('action.remove')" @click="(event) => removeItem(event, item)">{{ $t('action.remove') }}</button>
        </div>
        <h6 class="product-price">{{ convertToCurrency(item.total) }}</h6>
      </div>

      <table class="table table-borderless w-100">
        <tbody>
          <tr>
            <td>
              {{ $t('order.subtotal') }}
            </td>
            <td class="text-right"><h6 class="mb-0">{{ convertToCurrency(sharedState.total) }}</h6></td>
          </tr>
          <tr v-show="defaultDeliveryCost !== 0">
            <td>
              {{ $t('order.delivery_cost') }}
            </td>
            <td class="text-right border-bottom"><h6 class="mb-0">{{ convertToCurrency(defaultDeliveryCost) }}</h6></td>
          </tr>
          <tr>
            <td>
              {{ $t('order.total') }}
            </td>
            <td class="text-right"><h6 class="mb-0">{{ convertToCurrency(sharedState.total + defaultDeliveryCost) }}</h6></td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal -->
    <modal-item-form :modal-id="itemFormModalId" :init-item="selectedItem" @update="updateItem" :is-new="false" data-backdrop="false"></modal-item-form>
  </div>
</template>

<script>
import { wemeikPopup } from '../core'
import { convertToCurrency, isTheMaximumQuantity } from '../../utils/functions'
import { disableButton, enableButton, getButtonTargetted } from '../../utils/buttons'
import ModalItemForm from './ModalItemForm'
import SecureImage from './SecureImage'

export default {
  props: {
    defaultDeliveryCost: { type: Number, default: 0 }
  },
  data () {
    return {
      itemFormModalId: 'cartItemFormModal',
      sharedState: window.cartStore.state,
      selectedItem: {}
    }
  },
  components: { 'modal-item-form': ModalItemForm, 'secure-image': SecureImage },
  computed: {
    hasItems () {
      return (Array.isArray(this.sharedState.items) && this.sharedState.items.length > 0) || this.sharedState.count > 0
    }
  },
  methods: {
    convertToCurrency: convertToCurrency,
    decrementItemQuantity (item) {
      if (item.quantity > 1) {
        item.quantity = parseFloat(item.quantity) - 1
        this.updateTotal(item)
      }
    },
    editItem (item) {
      this.selectedItem = Object.assign({}, this.selectedItem, item)
      window.jQuery(`#${this.itemFormModalId}`).modal('show')
    },
    extractSpecifications (item) {
      let specifications = ''

      specifications += item.additionals
        .filter((a) => a.checked)
        .map((a) => a.name)
        .concat(item.observations.filter((a) => a.checked).map((a) => a.name))
        .join(' + ')

      return specifications
    },
    formatName (item) {
      let formattedName = item.name

      if (item.fraction_id) {
        const selectedFraction = item.fractions.find(
          (fraction) => fraction.id === item.fraction_id
        )
        formattedName += ` <small class="text-muted">(${selectedFraction.description})</small>`
      }

      return formattedName
    },
    incrementItemQuantity (item) {
      item.quantity = isTheMaximumQuantity(item.quantity, item.maximum_quantity) ? item.quantity : (item.quantity + 1)
      this.updateTotal(item)
    },
    removeItem (event, item) {
      const removeButton = getButtonTargetted(event.target)
      disableButton(removeButton)

      wemeikPopup({
        title:
          removeButton.dataset.question || this.$t('question.are_you_sure'),
        icon: 'warning',
        dangerMode: false,
        buttons: {
          cancel: removeButton.dataset.cancel || this.$t('action.cancel'),
          confirm: removeButton.dataset.confirm || removeButton.title
        }
      }).then((willRemove) => {
        if (willRemove) {
          window.cartStore.removeItem(item.id)
        } else {
          enableButton(removeButton)
        }
      })
    },
    updateItem (item, showPopup = true) {
      window.cartStore.updateItem(item)
      window.jQuery(`#${this.itemFormModalId}`).modal('hide')

      if (showPopup) {
        wemeikPopup({
          title: this.$t('alert.success'),
          text: this.$t('item.messages.updated_in_cart'),
          icon: 'success',
          timer: 3000
        })
      }
    },
    updateTotal (item) {
      item.total =
        item.quantity *
        (item.price +
          item.additionals.reduce(
            (accumulator, a) =>
              accumulator + (a.checked ? parseFloat(a.price) : 0),
            0
          ))
      this.updateItem(item, false)
    }
  }
}
</script>
